module.exports = __webpack_public_path__ + "static/media/ic_droptabela_ocultar.e9be067a.svg";